<template>
  <div class="AppointmentProfile">

    <h1 class="m-label" style="margin: 0">
      AP基本情報
    </h1>

    <template v-if="appointment.id == edit_id.appointment_id">

      <form @submit.prevent="patchAppointment(appointment)">
        <div class="m-box__inner">

          <table class="m-detail">
            <template v-if="!valid">
              <tr>
                <th>エラー</th>
                <td class="errors"><div>{{errors}}が入力されていません</div></td>
              </tr>
            </template>
            <!-- <tr> -->
            <!--   <th>ID</th> -->
            <!--   <td><div class="calc">{{appointment.id}}</div></td> -->
            <!-- </tr> -->
            <tr>
              <th>確認TEL</th>
              <td><multiselect v-model="watch.confirm_check" :options="confirm_check" label="name" :searchable="false" :show-labels="false" placeholder="確認TEL"></multiselect></td>
            </tr>
            <tr>
              <th>状態</th>
              <td><multiselect v-model="watch.state" :options="state" label="name" :searchable="false" :show-labels="false" placeholder="状態"></multiselect></td>
            </tr>
            <tr>
              <th class="req">営業所</th>
              <td><multiselect v-model="watch.office_id" :options="offices" label="name" :searchable="false" :show-labels="false" placeholder="営業所"></multiselect></td>
            </tr>
            <tr>
              <th>問合せ日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="appointment.contact_date" placeholder="問合せ日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">問い合わせ方法</th>
              <td class="checkbox">
                <div>
                  <label for="contact_method_0">未選択</label>
                  <input type="radio" name="contact_method" required id="contact_method_0" value="0" v-model="appointment.contact_method" @keypress.self.prevent.13>
                  <label for="contact_method_1">TEL</label>
                  <input type="radio" name="contact_method" id="contact_method_1" value="1" v-model="appointment.contact_method" @keypress.self.prevent.13>
                  <label for="contact_method_2">MAIL</label>
                  <input type="radio" name="contact_method" id="contact_method_2" value="2" v-model="appointment.contact_method" @keypress.self.prevent.13>
                  <label for="contact_method_3">その他</label>
                  <input type="radio" name="contact_method" id="contact_method_3" value="3" v-model="appointment.contact_method" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>問合せ結果</th>
              <td><multiselect v-model="watch.support" :options="support" label="name" :searchable="false" :show-labels="false" placeholder="問合せ結果"></multiselect></td>
            </tr>
            <tr>
              <th>問合せ結果詳細</th>
              <td><multiselect v-model="watch.missing_detail" :options="missing_detail" label="name" :searchable="false" :show-labels="false" placeholder="問合せ結果詳細"></multiselect></td>
            </tr>
            <tr>
              <th>今後連絡できるか</th>
              <td><multiselect v-model="watch.contact_later" :options="contact_later" label="name" :searchable="false" :show-labels="false" placeholder="今後連絡できるか"></multiselect></td>
            </tr>
            <tr>
              <th>次回連絡予定日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="appointment.next_contact_date" placeholder="次回連絡予定日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>次回連絡手段</th>
              <td><multiselect v-model="watch.next_contact_method" :options="next_contact_method" label="name" :searchable="false" :show-labels="false" placeholder="次回連絡手段"></multiselect></td>
            </tr>
            <tr>
              <th>営業結果</th>
              <td><multiselect v-model="watch.result" :options="result" label="name" :searchable="false" :show-labels="false" placeholder="営業結果"></multiselect></td>
            </tr>
            <tr>
              <th class="req">取得日</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="appointment.acquisition_date" placeholder="取得日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>AP種類</th>
              <td><multiselect v-model="watch.ap_type" :options="ap_type" label="name" :searchable="false" :show-labels="false" placeholder="AP種類"></multiselect></td>
            </tr>
            <tr>
              <th class="req">媒体</th>
              <td class="checkbox">
                <div>
                  <label for="mi">未選択</label>
                  <input type="checkbox" id="mi" value="0" v-model="mediumArray" @keypress.self.prevent.13>
                  <label for="dm">DM</label>
                  <input type="checkbox" id="dm" value="1" v-model="mediumArray" @keypress.self.prevent.13>
                  <label for="hg">貼紙</label>
                  <input type="checkbox" id="hg" value="2" v-model="mediumArray" @keypress.self.prevent.13>
                  <label for="hp">HP</label>
                  <input type="checkbox" id="hp" value="3" v-model="mediumArray" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="shokai">紹介</label>
                  <input type="checkbox" id="shokai" value="4" v-model="mediumArray" @keypress.self.prevent.13>
                  <label for="telchu">TEL注</label>
                  <input type="checkbox" id="telchu" value="5" v-model="mediumArray" @keypress.self.prevent.13>
                  <label for="ta">TA</label>
                  <input type="checkbox" id="ta" value="6" v-model="mediumArray" @keypress.self.prevent.13>
                  <label for="other">その他</label>
                  <input type="checkbox" id="other" value="7" v-model="mediumArray" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>HP閲覧</th>
              <td><multiselect v-model="watch.hp_browse" :options="hp_browse" label="name" :searchable="false" :show-labels="false" placeholder="HP閲覧"></multiselect></td>
            </tr>
            <tr>
              <th>HP種類</th>
              <td><multiselect v-model="watch.hp_type" :options="hp_type" label="name" :searchable="false" :show-labels="false" placeholder="HP種類"></multiselect></td>
            </tr>
            <tr>
              <th>APメモ</th>
              <td><input type='text' v-model="appointment.memo" placeholder="APメモ" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>DM届いた月</th>
              <td><input type="text" maxlength="7" minlength="7" v-model="appointment.dm" placeholder="DM届いた月" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>DM情報</th>
              <td><multiselect v-model="watch.dm_information" :options="dm_information" label="name" :searchable="false" :show-labels="false" placeholder="DM情報"></multiselect></td>
            </tr>
            <tr>
              <th>店種類</th>
              <td><multiselect v-model="watch.shop_type" :options="shop_type" label="name" :searchable="false" :show-labels="false" placeholder="店種類"></multiselect></td>
            </tr>
            <tr>
              <th>店名</th>
              <td><input type='text' v-model="appointment.shop_name" placeholder="店名" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">訪問日</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="appointment.visit_date" placeholder="訪問日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">訪問時間</th>
              <td><input type='text' v-model="appointment.visit_time" placeholder="訪問時間" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>保留上げ日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="appointment.next_visit_date" placeholder="保留上げ日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>保留上げ時間</th>
              <td><input type='text' v-model="appointment.next_visit_time" placeholder="保留上げ時間" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>希望曜日</th>
              <td><input type="text" v-model="appointment.request_of_day_of_week" placeholder="希望曜日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>希望曜日備考</th>
              <td><textarea type='text' v-model="appointment.request_of_day_of_week_note" placeholder="希望曜日備考"></textarea></td>
            </tr>
            <tr>
              <th>AP応対者</th>
              <td><input type='text' v-model="appointment.person" placeholder="AP応対者" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>話した相手</th>
              <td><multiselect v-model="watch.contact_person" :options="contact_person" label="name" :searchable="false" :show-labels="false" placeholder="話した相手"></multiselect></td>
            </tr>
          </table>

          <table class="m-detail center">
            <!-- <tr> -->
            <!--   <th>Famiy ID</th> -->
            <!--   <td><input type="text" v&#45;model="appointment.family_id" @keypress.self.prevent.13></td> -->
            <!-- </tr> -->
            <tr>
              <th>メイン名前</th>
              <td><input type="text" class="name_w" v-model="appointment.f_name" @keypress.self.prevent.13><input type="text" class="name_w" v-model="appointment.l_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>メインかな</th>
              <td><input type="text" class="name_w" v-model="appointment.f_name_kana" @keypress.self.prevent.13><input type="text" class="name_w" v-model="appointment.l_name_kana" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>郵便番号</th>
              <td><input type="text" v-model="appointment.zip" @keyup="getYubin" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>都道府県</th>
              <td><multiselect v-model="watch.pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="都道府県"></multiselect></td>
            </tr>
            <tr>
              <th class="req">市区町村・番地</th>
              <td>
                <input type="text" v-model="appointment.address1" @keypress.self.prevent.13>
              </td>
            </tr>
            <tr>
              <th class="req">建物名・部屋番号</th>
              <td>
                <input type="text" v-model="appointment.address2" @keypress.self.prevent.13>
              </td>
            </tr>
            <tr>
              <th>携帯TEL</th>
              <td><input type='text' maxlength="11" minlength="10" v-model="appointment.tel1" placeholder="携帯TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>固定TEL</th>
              <td><input type='text' maxlength="11" minlength="10" v-model="appointment.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>前日確認TEL連絡先</th>
              <td><multiselect v-model="watch.preferred_contact" :options="preferred_contact" label="name" :searchable="false" :show-labels="false" placeholder="前日確認TEL連絡先"></multiselect></td>
            </tr>
            <tr>
              <th>時間帯</th>
              <td><input type='text' v-model="appointment.contact_timezone" placeholder="時間帯" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>FAX</th>
              <td><input type="text" v-model="appointment.fax" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>MAIL</th>
              <td><input type="text" v-model="appointment.mail" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>公/国/私</th>
              <td class="checkbox">
                <div>
                  <label for="school_type_0">未選択</label>
                  <input type="radio" id="school_type_0" value="0" v-model="appointment.school_type" @keypress.self.prevent.13>
                  <label for="school_type_1">公立</label>
                  <input type="radio" id="school_type_1" value="1" v-model="appointment.school_type" @keypress.self.prevent.13>
                  <label for="school_type_2">国立</label>
                  <input type="radio" id="school_type_2" value="2" v-model="appointment.school_type" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="school_type_3">私立</label>
                  <input type="radio" id="school_type_3" value="3" v-model="appointment.school_type" @keypress.self.prevent.13>
                  <label for="school_type_4">その他</label>
                  <input type="radio" id="school_type_4" value="4" v-model="appointment.school_type" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>学校名</th>
              <td><input type="text" v-model="appointment.school_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>小/中/高/幼</th>
              <td><multiselect v-model="watch.school_stage" :options="school_stage" label="name" :searchable="false" :show-labels="false" placeholder="小/中/高/幼"></multiselect></td>
            </tr>
            <tr>
              <th>学年</th>
              <td><multiselect v-model="watch.grade" :options="grade" label="name" :searchable="false" :show-labels="false" placeholder="学年" :show-labes="false"></multiselect></td>
            </tr>
            <tr>
              <th>性別</th>
              <td class="checkbox">
                <div>
                  <label for="gender_0">未選択</label>
                  <input type="radio" id="gender_0" value="0" v-model="appointment.gender" @keypress.self.prevent.13>
                  <label for="gender_1">男</label>
                  <input type="radio" id="gender_1" value="1" v-model="appointment.gender" @keypress.self.prevent.13>
                  <label for="gender_2">女</label>
                  <input type="radio" id="gender_2" value="2" v-model="appointment.gender" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>サブ名前</th>
              <td><input type="text" class="name_w" v-model="appointment.sub_f_name" @keypress.self.prevent.13><input type="text" class="name_w" v-model="appointment.sub_l_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>サブかな</th>
              <td><input type="text" class="name_w" v-model="appointment.sub_f_name_kana" @keypress.self.prevent.13><input type="text" class="name_w" v-model="appointment.sub_l_name_kana" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>サブ公/国/私</th>
              <td class="checkbox">
                <div>
                  <label for="sub_school_type_0">未選択</label>
                  <input type="radio" id="sub_school_type_0" value="0" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
                  <label for="sub_school_type_1">公立</label>
                  <input type="radio" id="sub_school_type_1" value="1" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
                  <label for="sub_school_type_2">国立</label>
                  <input type="radio" id="sub_school_type_2" value="2" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="sub_school_type_3">私立</label>
                  <input type="radio" id="sub_school_type_3" value="3" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
                  <label for="sub_school_type_4">その他</label>
                  <input type="radio" id="sub_school_type_4" value="4" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>サブ学校名</th>
              <td><input type="text" v-model="appointment.sub_school_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>サブ小/中/高/幼</th>
              <td><multiselect v-model="watch.sub_school_stage" :options="school_stage" label="name" :searchable="false" :show-labels="false" placeholder="サブ小/中/高/幼"></multiselect></td>
            </tr>
            <tr>
              <th>サブ学年</th>
              <td><multiselect v-model="watch.sub_grade" :options="grade" label="name" :searchable="false" :show-labels="false" placeholder="サブ学年" :show-labes="false"></multiselect></td>
            </tr>
            <tr>
              <th>サブ性別</th>
              <td class="checkbox">
                <div>
                  <label for="sub_gender_0">未選択</label>
                  <input type="radio" id="sub_gender_0" value="0" v-model="appointment.sub_gender" @keypress.self.prevent.13>
                  <label for="sub_gender_1">男</label>
                  <input type="radio" id="sub_gender_1" value="1" v-model="appointment.sub_gender" @keypress.self.prevent.13>
                  <label for="sub_gender_2">女</label>
                  <input type="radio" id="sub_gender_2" value="2" v-model="appointment.sub_gender" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
          </table>

          <table class="m-detail">
            <tr>
              <th>駐車場</th>
              <td class="checkbox">
                <div>
                  <label for="parking_0">未選択</label>
                  <input type="radio" id="parking_0" value="0" v-model="appointment.parking" @keypress.self.prevent.13>
                  <label for="parking_1">有</label>
                  <input type="radio" id="parking_1" value="1" v-model="appointment.parking" @keypress.self.prevent.13>
                  <label for="parking_2">無</label>
                  <input type="radio" id="parking_2" value="2" v-model="appointment.parking" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>駐車場備考</th>
              <td><input type="text" v-model="appointment.parking_note" placeholder="駐車場備考" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>メイン成績</th>
              <td><input type="text" v-model="appointment.achievement" placeholder="メイン成績" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>メイン習い事</th>
              <td><input type="text" v-model="appointment.learning" placeholder="メイン習い事" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>メイン習い事いつから</th>
              <td><input type="text" v-model="appointment.learning_start_period" placeholder="メイン習い事いつから" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>メイン習い事きっかけ</th>
              <td><input type="text" v-model="appointment.learning_nervous" placeholder="メイン習い事きっかけ" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>メイン習い事成果</th>
              <td><multiselect v-model="watch.learning_result" :options="learning_result" label="name" :searchable="false" :show-labels="false" placeholder="メイン習い事成果"></multiselect></td>
            </tr>
            <tr>
              <th>メイン習い事継続</th>
              <td><multiselect v-model="watch.learning_continuation" :options="learning_continuation" label="name" :searchable="false" :show-labels="false" placeholder="メイン習い事継続"></multiselect></td>
            </tr>
            <tr>
              <th>サブ成績</th>
              <td><input type="text" v-model="appointment.sub_achievement" placeholder="サブ成績" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>サブ習い事</th>
              <td><input type="text" v-model="appointment.sub_learning" placeholder="サブ習い事" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>サブ習い事いつから</th>
              <td><input type="text" v-model="appointment.sub_learning_start_period" placeholder="サブ習い事いつから" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>サブ習い事きっかけ</th>
              <td><input type="text" v-model="appointment.sub_learning_nervous" placeholder="サブ習い事きっかけ" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>サブ習い事成果</th>
              <td><multiselect v-model="watch.sub_learning_result" :options="learning_result" label="name" :searchable="false" :show-labels="false" placeholder="サブ習い事成果"></multiselect></td>
            </tr>
            <tr>
              <th>サブ習い事継続</th>
              <td><multiselect v-model="watch.sub_learning_continuation" :options="learning_continuation" label="name" :searchable="false" :show-labels="false" placeholder="サブ習い事継続"></multiselect></td>
            </tr>
            <tr>
              <th>当日の同席者</th>
              <td class="checkbox">
                <div>
                  <label for="a">母</label>
                  <input type="checkbox" id="a" value="母" v-model="attendedArray" @keypress.self.prevent.13>
                  <label for="b">父</label>
                  <input type="checkbox" id="b" value="父" v-model="attendedArray" @keypress.self.prevent.13>
                  <label for="c">祖母</label>
                  <input type="checkbox" id="c" value="祖母" v-model="attendedArray" @keypress.self.prevent.13>
                  <label for="d">祖父</label>
                  <input type="checkbox" id="d" value="祖父" v-model="attendedArray" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="oba">伯母</label>
                  <input type="checkbox" id="oba" value="伯母" v-model="attendedArray" @keypress.self.prevent.13>
                  <label for="oji">伯父</label>
                  <input type="checkbox" id="oji" value="伯父" v-model="attendedArray" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>父親の絡み</th>
              <td class="checkbox">
                <div>
                  <label for="fathers_involvement_0">未選択</label>
                  <input type="radio" id="fathers_involvement_0" value="0" v-model="appointment.fathers_involvement" @keypress.self.prevent.13>
                  <label for="fathers_involvement_1">有</label>
                  <input type="radio" id="fathers_involvement_1" value="1" v-model="appointment.fathers_involvement" @keypress.self.prevent.13>
                  <label for="fathers_involvement_2">無</label>
                  <input type="radio" id="fathers_involvement_2" value="2" v-model="appointment.fathers_involvement" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>特記事項</th>
              <td class="checkbox">
                <div>
                  <label for="e">母子父子家庭</label>
                  <input type="checkbox" id="e" value="母子・父子家庭" v-model="noticesArray" @keypress.self.prevent.13>
                  <label for="f">ﾊﾞｯﾃｨﾝｸﾞ</label>
                  <input type="checkbox" id="f" value="バッティング" v-model="noticesArray" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="g">不登校</label>
                  <input type="checkbox" id="g" value="不登校" v-model="noticesArray" @keypress.self.prevent.13>
                  <label for="h">障害</label>
                  <input type="checkbox" id="h" value="障害" v-model="noticesArray" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>送るもの</th>
              <td class="checkbox">
                <div>
                  <label for="n">体験案内</label>
                  <input type="checkbox" id="n" value="体験案内" v-model="sending_productsArray" @keypress.self.prevent.13>
                  <label for="o">資料</label>
                  <input type="checkbox" id="o" value="資料" v-model="sending_productsArray" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="p">料金表</label>
                  <input type="checkbox" id="p" value="料金表" v-model="sending_productsArray" @keypress.self.prevent.13>
                  <label for="q">Quoカード</label>
                  <input type="checkbox" id="q" value="Quoカード" v-model="sending_productsArray" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="r">ギフトカード</label>
                  <input type="checkbox" id="r" value="ギフトカード" v-model="sending_productsArray" @keypress.self.prevent.13>
                  <label for="s">キャンペーンチラシ</label>
                  <input type="checkbox" id="s" value="キャンペーンチラシ" v-model="sending_productsArray" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="t">送らない</label>
                  <input type="checkbox" id="t" value="送らない" v-model="sending_productsArray" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>送る方法</th>
              <td><multiselect v-model="watch.sending_method" :options="sending_method" label="name" :searchable="false" :show-labels="false" placeholder="送る方法"></multiselect></td>
            </tr>
            <tr>
              <th>郵送・FAX / 予定日</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="appointment.sending_date" placeholder="郵送・FAX / 予定日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>送信時間</th>
              <td><input type="text" v-model="appointment.sending_time" placeholder="送信時間" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>確認項目</th>
              <td class="checkbox">
                <div>
                  <label for="kaisya">会社名</label>
                  <input type="checkbox" id="kaisya" v-model="watch.transmission_item_company" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="hutatoori">2通りの教え方</label>
                  <input type="checkbox" id="hutatoori" v-model="watch.transmission_item_course" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="taiken">体験はADが訪問</label>
                  <input type="checkbox" id="taiken" v-model="watch.transmission_item_visitor" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="mokuteki">勧誘する目的</label>
                  <input type="checkbox" id="mokuteki" v-model="watch.transmission_item_purpose" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="nijikan">体験は2時間</label>
                  <input type="checkbox" id="nijikan" v-model="watch.transmission_item_requiredtime" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
          </table>

          <table class="note">
            <tr>
              <th>備考</th>
              <td><textarea type='text' v-model="appointment.note" placeholder="備考"></textarea></td>
              <!-- <vue-html5-editor @change="patchNote(appointment, $event)" :content="appointment.note" :auto-height="false"></vue-html5-editor> -->
            </tr>
          </table>

        </div>

        <div style="display: flex">
          <btn class="m-btn m-btn--default"><i class="fa fa-pencil-square-o"></i>更新</btn>
          <btn class="m-btn m-btn--default cancel" type="button" @click.native.prevent="cancelAppointment(appointment)"><i class="fa fa-pencil-square-o"></i>キャンセル</btn>
        </div>
      </form>
    </template>
    <template v-if="appointment.id !== edit_id.appointment_id">
      <div class="m-box__inner">

        <table class="m-detail">
          <template v-if="!valid">
            <tr>
              <th>エラー</th>
              <td class="errors"><div>{{errors}}が入力されていません</div></td>
            </tr>
          </template>
          <!-- <tr> -->
          <!--   <th>ID</th> -->
          <!--   <td>{{appointment.id}}</td> -->
          <!-- </tr> -->
          <tr>
            <th>確認TEL</th>
            <template v-if="appointment.confirm_check">
              <td>{{confirmCheckName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>状態</th>
            <template v-if="appointment.state">
              <td>{{stateName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>営業所</th>
            <template v-if="appointment.office_id">
              <td>{{officeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>問合せ日</th>
            <td>{{appointment.contact_date}}</td>
          </tr>
          <tr>
            <th>問い合わせ方法</th>
            <template v-if="appointment.contact_method">
              <td>{{contactMethodName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>問合せ結果</th>
            <template v-if="appointment.support">
              <td>{{supportName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>問合せ結果詳細</th>
            <template v-if="appointment.missing_detail">
              <td>{{missingDetailName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>今後連絡できるか</th>
            <template v-if="appointment.contact_later">
              <td>{{contactLaterName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>次回連絡予定日</th>
            <td>{{appointment.next_contact_date}}</td>
          </tr>
          <tr>
            <th>次回連絡手段</th>
            <template v-if="appointment.next_contact_method">
              <td>{{nextContactMethodName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>営業結果</th>
            <template v-if="appointment.result">
              <td>{{resultName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>取得日</th>
            <td>{{appointment.acquisition_date}}</td>
          </tr>
          <tr>
            <th>AP種類</th>
            <template v-if="appointment.ap_type">
              <td>{{apTypeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>媒体</th>
            <td>
              <template v-if="appointment.medium1">
                {{medium1Name}}
              </template>
              <template v-else>
              </template>

              <template v-if="appointment.medium2">
                {{medium2Name}}
              </template>
              <template v-else>
              </template>

              <template v-if="appointment.medium3">
                {{medium3Name}}
              </template>
              <template v-else>
              </template>
            </td>
          </tr>
          <tr>
            <th>HP閲覧</th>
            <template v-if="appointment.hp_browse">
              <td>{{hpBrowseName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>HP種類</th>
            <template v-if="appointment.hp_type">
              <td>{{hpTypeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>APメモ</th>
            <td>{{appointment.memo}}</td>
          </tr>
          <tr>
            <th>DM届いた月</th>
            <td>{{appointment.dm}}</td>
          </tr>
          <tr>
            <th>DM情報</th>
            <template v-if="appointment.dm_information">
              <td>{{dmInformationName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>店種類</th>
            <template v-if="appointment.shop_type">
              <td>{{shopTypeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>店名</th>
            <td>{{appointment.shop_name}}</td>
          </tr>
          <tr>
            <th>訪問日</th>
            <td>{{appointment.visit_date}}</td>
          </tr>
          <tr>
            <th>訪問時間</th>
            <td>{{appointment.visit_time}}</td>
          </tr>
          <tr>
            <th>保留上げ日</th>
            <td>{{appointment.next_visit_date}}</td>
          </tr>
          <tr>
            <th>保留上げ時間</th>
            <td>{{appointment.next_visit_time}}</td>
          </tr>
          <tr>
            <th>希望曜日</th>
            <td>{{appointment.request_of_day_of_week}}</td>
          </tr>
          <tr>
            <th>希望曜日備考</th>
            <td>{{appointment.request_of_day_of_week_note}}</td>
          </tr>
          <tr>
            <th>AP応対者</th>
            <td>{{appointment.person}}</td>
          </tr>
          <tr>
            <th>話した相手</th>
            <template v-if="appointment.contact_person">
              <td>{{contactPersonName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
        </table>

        <table class="m-detail center">
          <!-- <tr> -->
          <!--   <th>Famiy ID</th> -->
          <!--   <td>{{appointment.family_id}}</td> -->
          <!-- </tr> -->
          <tr>
            <th>名前</th>
            <td>{{appointment.f_name}} {{appointment.l_name}}</td>
          </tr>
          <tr>
            <th>かな</th>
            <td>{{appointment.f_name_kana}} {{appointment.l_name_kana}}</td>
          </tr>
          <tr>
            <th>郵便番号</th>
            <td>{{appointment.zip}}</td>
          </tr>
          <tr>
            <th>都道府県</th>
            <template v-if="appointment.pref">
              <td>{{prefName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>市区町村・番地</th>
            <td>{{appointment.address1}}</td>
          </tr>
          <tr>
            <th>建物名・部屋番号</th>
            <td>{{appointment.address2}}</td>
          </tr>
          <tr>
            <th>携帯TEL</th>
            <td>{{appointment.tel1}}</td>
          </tr>
          <tr>
            <th>固定TEL</th>
            <td>{{appointment.tel2}}</td>
          </tr>
          <tr>
            <th>前日確認TEL連絡先</th>
            <template v-if="appointment.preferred_contact">
              <td>{{preferredContactName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>時間帯</th>
            <td>{{appointment.contact_timezone}}</td>
          </tr>
          <tr>
            <th>FAX</th>
            <td>{{appointment.fax}}</td>
          </tr>
          <tr>
            <th>MAIL</th>
            <td>{{appointment.mail}}</td>
          </tr>
          <tr>
            <th>公/国/私</th>
            <template v-if="appointment.school_type">
              <td>{{schoolTypeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>学校名</th>
            <td>{{appointment.school_name}}</td>
          </tr>
          <tr>
            <th>小/中/高/幼</th>
            <template v-if="appointment.school_stage">
              <td>{{schoolStageName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>学年</th>
            <template v-if="appointment.grade">
              <td>{{gradeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>性別</th>
            <template v-if="appointment.gender">
              <td>{{genderName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>サブ名前</th>
            <td>{{appointment.sub_f_name}} {{appointment.sub_l_name}}</td>
          </tr>
          <tr>
            <th>サブかな</th>
            <td>{{appointment.sub_f_name_kana}} {{appointment.sub_l_name_kana}}</td>
          </tr>
          <tr>
            <th>サブ公/国/私</th>
            <template v-if="appointment.sub_school_type">
              <td>{{subSchoolTypeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>サブ学校名</th>
            <td>{{appointment.sub_school_name}}</td>
          </tr>
          <tr>
            <th>サブ小/中/高/幼</th>
            <template v-if="appointment.sub_school_stage">
              <td>{{subSchoolStageName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>サブ学年</th>
            <template v-if="appointment.sub_grade">
              <td>{{subGradeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>サブ性別</th>
            <template v-if="appointment.sub_gender">
              <td>{{subGenderName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>駐車場</th>
            <template v-if="appointment.parking">
              <td>{{parkingName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>駐車場備考</th>
            <td>{{appointment.parking_note}}</td>
          </tr>
        </table>

        <table class="m-detail">
          <tr>
            <th>メイン成績</th>
            <td>{{appointment.achievement}}</td>
          </tr>
          <tr>
            <th>メイン習い事</th>
            <td>{{appointment.learning}}</td>
          </tr>
          <tr>
            <th>メイン習い事いつから</th>
            <td>{{appointment.learning_start_period}}</td>
          </tr>
          <tr>
            <th>メイン習い事きっかけ</th>
            <td>{{appointment.learning_nervous}}</td>
          </tr>
          <tr>
            <th>メイン習い事成果</th>
            <template v-if="appointment.learning_result">
              <td>{{learningResultName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>メイン習い事継続</th>
            <template v-if="appointment.learning_continuation">
              <td>{{learningContinuationName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>サブ成績</th>
            <td>{{appointment.sub_achievement}}</td>
          </tr>
          <tr>
            <th>サブ習い事</th>
            <td>{{appointment.sub_learning}}</td>
          </tr>
          <tr>
            <th>サブ習い事いつから</th>
            <td>{{appointment.sub_learning_start_period}}</td>
          </tr>
          <tr>
            <th>サブ習い事きっかけ</th>
            <td>{{appointment.sub_learning_nervous}}</td>
          </tr>
          <tr>
            <th>サブ習い事成果</th>
            <template v-if="appointment.sub_learning_result">
              <td>{{subLearningResultName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>サブ習い事継続</th>
            <template v-if="appointment.sub_learning_continuation">
              <td>{{subLearningContinuationName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>当日の同席者</th>
            <td>{{appointment.attended}}</td>
          </tr>
          <tr>
            <th>父親の絡み</th>
            <template v-if="appointment.fathers_involvement">
              <td>{{fathersInvolvementName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>特記事項</th>
            <td>{{appointment.notices}}</td>
          </tr>
          <tr>
            <th>送るもの</th>
            <td>{{appointment.sending_products}}</td>
          </tr>
          <tr>
            <th>送る方法</th>
            <template v-if="appointment.sending_method">
              <td>{{sendingMethodName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>郵送・FAX / 予定日</th>
            <td>{{appointment.sending_date}}</td>
          </tr>
          <tr>
            <th>送信時間</th>
            <td>{{appointment.sending_time}}</td>
          </tr>
          <tr>
            <th>確認: 会社名</th>
            <template v-if="appointment.transmission_item_company">
              <td>{{transmissionItemCompanyName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>確認: 2通り</th>
            <template v-if="appointment.transmission_item_course">
              <td>{{transmissionItemCourseName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>確認: 体験はAD</th>
            <template v-if="appointment.transmission_item_visitor">
              <td>{{transmissionItemVisitorName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>確認: 勧誘目的</th>
            <template v-if="appointment.transmission_item_purpose">
              <td>{{transmissionItemPurposeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>確認: 体験は2時間</th>
            <template v-if="appointment.transmission_item_requiredtime">
              <td>{{transmissionItemRequiredName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
        </table>

        <table class="note">
          <tr>
            <th>備考</th>
            <td style="white-space: pre-wrap">{{appointment.note}}</td>
          </tr>
        </table>

      </div>
      <btn @click.native="edit(appointment)" style="border-right: solid 1px #ccc"><i class="fa fa-pencil-square-o"></i>編集</btn>
    </template>
  </div>
</template>

<script>
let jsonp = require('jsonp')
export default {
  props: {
    appointment: Object,
    edit_id: Object
  },
  data () {
    return {
      attendedArray: [],
      noticesArray: [],
      sending_productsArray: [],
      mediumArray: [],
      geometry: '',
      watch: {
        confirm_check: '',
        state: '',
        pref: '',
        support: '',
        missing_detail: '',
        contact_later: '',
        result: '',
        ap_type: '',
        hp_type: '',
        office_id: '',
        school_stage: '',
        grade: '',
        dm_information: '',
        next_contact_method: '',
        shop_type: '',
        hp_browse: '',
        contact_person: '',
        sub_school_stage: '',
        sub_grade: '',
        learning_result: '',
        learning_continuation: '',
        sub_learning_result: '',
        sub_learning_continuation: '',
        sending_method: '',
        preferred_contact: '',
        transmission_item_company: '',
        transmission_item_course: '',
        transmission_item_visitor: '',
        transmission_item_purpose: '',
        transmission_item_requiredtime: ''
      },
      confirm_check: [
        { name: '', value: 0 },
        { name: '○', value: 1 }
      ]
    }
  },
  computed: {
    state () {
      return this.$store.getters['appointments/state']
    },

    support () {
      return this.$store.getters['appointments/support']
    },

    missing_detail () {
      return this.$store.getters['appointments/missing_detail']
    },

    contact_later () {
      return this.$store.getters['appointments/contact_later']
    },

    result () {
      return this.$store.getters['appointments/result']
    },

    ap_type () {
      return this.$store.getters['appointments/ap_type']
    },

    medium () {
      return this.$store.getters['appointments/medium']
    },

    shop_type () {
      return this.$store.getters['appointments/shop_type']
    },

    hp_type () {
      return this.$store.getters['appointments/hp_type']
    },

    hp_browse () {
      return this.$store.getters['appointments/hp_browse']
    },

    gender () {
      return this.$store.getters['appointments/gender']
    },

    school_type () {
      return this.$store.getters['appointments/school_type']
    },

    school_stage () {
      return this.$store.getters['appointments/school_stage']
    },

    grade () {
      return this.$store.getters['appointments/grade']
    },

    dm_information () {
      return this.$store.getters['appointments/dm_information']
    },

    preferred_contact () {
      return this.$store.getters['appointments/preferred_contact']
    },

    contact_method () {
      return this.$store.getters['appointments/contact_method']
    },

    next_contact_method () {
      return this.$store.getters['appointments/next_contact_method']
    },

    contact_person () {
      return this.$store.getters['appointments/contact_person']
    },

    parking () {
      return this.$store.getters['appointments/parking']
    },

    learning_result () {
      return this.$store.getters['appointments/learning_result']
    },

    learning_continuation () {
      return this.$store.getters['appointments/learning_continuation']
    },

    fathers_involvement () {
      return this.$store.getters['appointments/fathers_involvement']
    },

    // notices () {
    //   return this.$store.getters['appointments/notices']
    // },

    // sending_products () {
    //   return this.$store.getters['appointments/sending_products']
    // },

    sending_method () {
      return this.$store.getters['appointments/sending_method']
    },

    maru () {
      return this.$store.getters['appointments/maru']
    },

    confirmCheckName () {
      return this.maru.filter(item => {
        return item.value === this.appointment.confirm_check
      })[0].name
    },

    stateName () {
      return this.state.filter(item => {
        return item.value === this.appointment.state
      })[0].name
    },

    contactMethodName () {
      return this.contact_method.filter(item => {
        return item.value === this.appointment.contact_method
      })[0].name
    },

    nextContactMethodName () {
      return this.next_contact_method.filter(item => {
        return item.value === this.appointment.next_contact_method
      })[0].name
    },

    supportName () {
      return this.support.filter(item => {
        return item.value === this.appointment.support
      })[0].name
    },

    missingDetailName () {
      return this.missing_detail.filter(item => {
        return item.value === this.appointment.missing_detail
      })[0].name
    },

    contactLaterName () {
      return this.contact_later.filter(item => {
        return item.value === this.appointment.contact_later
      })[0].name
    },

    resultName () {
      return this.result.filter(item => {
        return item.value === this.appointment.result
      })[0].name
    },

    apTypeName () {
      return this.ap_type.filter(item => {
        return item.value === this.appointment.ap_type
      })[0].name
    },

    medium1Name () {
      return this.medium.filter(item => {
        return item.value === this.appointment.medium1
      })[0].name
    },

    medium2Name () {
      return this.medium.filter(item => {
        return item.value === this.appointment.medium2
      })[0].name
    },

    medium3Name () {
      return this.medium.filter(item => {
        return item.value === this.appointment.medium3
      })[0].name
    },

    hpBrowseName () {
      return this.hp_browse.filter(item => {
        return item.value === this.appointment.hp_browse
      })[0].name
    },

    hpTypeName () {
      return this.hp_type.filter(item => {
        return item.value === this.appointment.hp_type
      })[0].name
    },

    dmInformationName () {
      return this.dm_information.filter(item => {
        return item.value === this.appointment.dm_information
      })[0].name
    },

    shopTypeName () {
      return this.shop_type.filter(item => {
        return item.value === this.appointment.shop_type
      })[0].name
    },

    contactPersonName () {
      return this.contact_person.filter(item => {
        return item.value === this.appointment.contact_person
      })[0].name
    },

    preferredContactName () {
      return this.preferred_contact.filter(item => {
        return item.value === this.appointment.preferred_contact
      })[0].name
    },

    schoolTypeName () {
      return this.school_type.filter(item => {
        return item.value === this.appointment.school_type
      })[0].name
    },

    schoolStageName () {
      return this.school_stage.filter(item => {
        return item.value === this.appointment.school_stage
      })[0].name
    },

    gradeName () {
      return this.grade.filter(item => {
        return item.value === this.appointment.grade
      })[0].name
    },

    genderName () {
      return this.gender.filter(item => {
        return item.value === this.appointment.gender
      })[0].name
    },

    subSchoolTypeName () {
      return this.school_type.filter(item => {
        return item.value === this.appointment.sub_school_type
      })[0].name
    },

    subSchoolStageName () {
      return this.school_stage.filter(item => {
        return item.value === this.appointment.sub_school_stage
      })[0].name
    },

    subGradeName () {
      return this.grade.filter(item => {
        return item.value === this.appointment.sub_grade
      })[0].name
    },

    subGenderName () {
      return this.gender.filter(item => {
        return item.value === this.appointment.sub_gender
      })[0].name
    },

    parkingName () {
      return this.parking.filter(item => {
        return item.value === this.appointment.parking
      })[0].name
    },

    learningResultName () {
      return this.learning_result.filter(item => {
        return item.value === this.appointment.learning_result
      })[0].name
    },

    learningContinuationName () {
      return this.learning_continuation.filter(item => {
        return item.value === this.appointment.learning_continuation
      })[0].name
    },

    subLearningResultName () {
      return this.learning_result.filter(item => {
        return item.value === this.appointment.sub_learning_result
      })[0].name
    },

    subLearningContinuationName () {
      return this.learning_continuation.filter(item => {
        return item.value === this.appointment.sub_learning_continuation
      })[0].name
    },

    fathersInvolvementName () {
      return this.fathers_involvement.filter(item => {
        return item.value === this.appointment.fathers_involvement
      })[0].name
    },

    sendingProductsName () {
      return this.sending_products.filter(item => {
        return item.value === this.appointment.sending_products
      })[0].name
    },

    sendingMethodName () {
      return this.sending_method.filter(item => {
        return item.value === this.appointment.sending_method
      })[0].name
    },

    transmissionItemCompanyName () {
      return this.maru.filter(item => {
        return item.value === this.appointment.transmission_item_company
      })[0].name
    },

    transmissionItemCourseName () {
      return this.maru.filter(item => {
        return item.value === this.appointment.transmission_item_course
      })[0].name
    },

    transmissionItemVisitorName () {
      return this.maru.filter(item => {
        return item.value === this.appointment.transmission_item_visitor
      })[0].name
    },

    transmissionItemPurposeName () {
      return this.maru.filter(item => {
        return item.value === this.appointment.transmission_item_purpose
      })[0].name
    },

    transmissionItemRequiredName () {
      return this.maru.filter(item => {
        return item.value === this.appointment.transmission_item_requiredtime
      })[0].name
    },

    offices () {
      return this.$store.getters.offices
    },

    officeName () {
      return this.offices.filter(office => {
        return office.id === this.appointment.office_id
      })[0].name
    },

    prefs () {
      return this.$store.getters.prefs
    },

    prefName () {
      return this.prefs.filter(pref => {
        return pref.id === this.appointment.pref
      })[0].name
    },

    dm () {
      if (this.appointment.dm) {
        let dm = new Date(this.appointment.dm)
        return dm.getFullYear() + '/' + ('0' + (dm.getMonth() + 1)).slice(-2)
      } else {
        return ''
      }
    },

    attended () {
      let attended = this.attendedArray.join()
      return attended
    },

    notices () {
      let notices = this.noticesArray.join()
      return notices
    },

    sending_products () {
      let sending_products = this.sending_productsArray.join()
      return sending_products
    },

    mediums () {
      let mediums = []
      if (this.appointment.medium1 !== 0) {
        mediums.push(this.appointment.medium1)
      }
      if (this.appointment.medium2 !== 0) {
        mediums.push(this.appointment.medium2)
      }
      if (this.appointment.medium3 !== 0) {
        mediums.push(this.appointment.medium3)
      }
      return mediums
    },

    // validation
    office_idErrors () {
      return this.appointment.office_id ? [] : ['営業所']
    },
    address1Errors () {
      return this.appointment.address1 ? [] : ['住所(市区町村・番地)']
    },
    contact_dateErrors () {
      return this.appointment.contact_date ? [] : ['問い合わせ日']
    },
    acquisition_dateErrors () {
      return this.appointment.acquisition_date ? [] : ['取得日']
    },
    supportErrors () {
      return this.appointment.support ? [] : ['AP結果']
    },
    contact_methodErrors () {
      return this.appointment.contact_method ? [] : ['問い合わせ方法']
    },
    visit_dateErrors () {
      return this.appointment.visit_date ? [] : ['訪問日']
    },
    sending_dateErrors () {
      return this.appointment.sending_date ? [] : ['郵送・FAX / 予定日']
    },

    errors () {
      let errors = [].concat(
        this.office_idErrors,
        this.address1Errors,
        this.contact_dateErrors,
        this.acquisition_dateErrors,
        this.supportErrors,
        this.contact_methodErrors,
        this.visit_dateErrors,
        this.sending_dateErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid () {
      return !this.errors
    }
  },
  watch: {
    'watch.preferred_contact': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.preferred_contact = now.value
      }
    },

    'watch.confirm_check': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.confirm_check = now.value
      }
    },

    'watch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.state = now.value
      }
    },

    'watch.pref': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.pref = now.id
        this.geometry = now.name
      }
    },

    'watch.support': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.support = now.value
      }
    },

    'watch.missing_detail': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.missing_detail = now.value
      }
    },

    'watch.contact_later': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.contact_later = now.value
      }
    },

    'watch.result': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.result = now.value
      }
    },

    'watch.ap_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.ap_type = now.value
      }
    },

    'watch.hp_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.hp_type = now.value
      }
    },

    'watch.office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.office_id = now.id
      }
    },

    'watch.gender': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.gender = now.value
      }
    },

    'watch.sub_gender': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.sub_gender = now.value
      }
    },

    'watch.school_stage': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.school_stage = now.value
      }
    },

    'watch.sub_school_stage': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.sub_school_stage = now.value
      }
    },

    'watch.grade': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.grade = now.value
      }
    },

    'watch.dm_information': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.dm_information = now.value
      }
    },

    'watch.next_contact_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.next_contact_method = now.value
      }
    },

    'watch.sub_grade': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.sub_grade = now.value
      }
    },

    'watch.shop_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.shop_type = now.value
      }
    },

    'watch.hp_browse': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.hp_browse = now.value
      }
    },

    'watch.contact_person': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.contact_person = now.value
      }
    },

    'watch.learning_result': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.learning_result = now.value
      }
    },

    'watch.learning_continuation': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.learning_continuation = now.value
      }
    },

    'watch.sub_learning_result': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.sub_learning_result = now.value
      }
    },

    'watch.sub_learning_continuation': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.sub_learning_continuation = now.value
      }
    },

    'watch.fathers_involvement': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.fathers_involvement = now.value
      }
    },

    'watch.sending_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.appointment.sending_method = now.value
      }
    },

    'watch.transmission_item_company': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.appointment.transmission_item_company = 1
      } else if (now === false) {
        this.appointment.transmission_item_company = 0
      }
    },

    'watch.transmission_item_course': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.appointment.transmission_item_course = 1
      } else if (now === false) {
        this.appointment.transmission_item_course = 0
      }
    },

    'watch.transmission_item_visitor': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.appointment.transmission_item_visitor = 1
      } else if (now === false) {
        this.appointment.transmission_item_visitor = 0
      }
    },

    'watch.transmission_item_purpose': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.appointment.transmission_item_purpose = 1
      } else if (now === false) {
        this.appointment.transmission_item_purpose = 0
      }
    },

    'watch.transmission_item_requiredtime': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.appointment.transmission_item_requiredtime = 1
      } else if (now === false) {
        this.appointment.transmission_item_requiredtime = 0
      }
    }
  },
  methods: {
    edit (appointment) {
      this.watch.preferred_contact = this.preferred_contact[this.appointment.preferred_contact]
      this.watch.confirm_check = this.confirm_check[this.appointment.confirm_check]
      this.watch.state = this.state[this.appointment.state]
      this.watch.pref = this.prefs.filter(pref => {
        return pref.id === this.appointment.pref
      })[0]
      this.watch.support = this.support[this.appointment.support]
      this.watch.missing_detail = this.missing_detail[this.appointment.missing_detail]
      this.watch.contact_later = this.contact_later[this.appointment.contact_later]
      this.watch.result = this.result[this.appointment.result]
      this.watch.ap_type = this.ap_type[this.appointment.ap_type]
      this.watch.hp_type = this.hp_type[this.appointment.hp_type]
      this.watch.office_id = this.offices.filter(office => {
        return office.id === this.appointment.office_id
      })[0]
      // this.watch.gender = this.gender[this.appointment.gender]
      // this.watch.sub_gender = this.gender[this.appointment.sub_gender]
      // this.watch.school_type = this.school_type[this.appointment.school_type]
      // this.watch.sub_school_type = this.school_type[this.appointment.sub_school_type]
      this.watch.school_stage = this.school_stage[this.appointment.school_stage]
      this.watch.sub_school_stage = this.school_stage[this.appointment.sub_school_stage]
      this.watch.grade = this.grade[this.appointment.grade]
      this.watch.dm_information = this.dm_information[this.appointment.dm_information]
      this.watch.next_contact_method = this.next_contact_method[this.appointment.next_contact_method]
      this.watch.sub_grade = this.grade[this.appointment.sub_grade]
      this.watch.shop_type = this.shop_type[this.appointment.shop_type]
      // this.watch.contact_method = this.contact_method[this.appointment.contact_method]
      this.watch.hp_browse = this.hp_browse[this.appointment.hp_browse]
      this.watch.contact_person = this.contact_person[this.appointment.contact_person]
      // this.watch.parking = this.parking[this.appointment.parking]
      this.watch.learning_result = this.learning_result[this.appointment.learning_result]
      this.watch.learning_continuation = this.learning_continuation[this.appointment.learning_continuation]
      this.watch.sub_learning_result = this.learning_result[this.appointment.sub_learning_result]
      this.watch.sub_learning_continuation = this.learning_continuation[this.appointment.sub_learning_continuation]
      // this.watch.fathers_involvement = this.fathers_involvement[this.appointment.fathers_involvement]
      this.watch.sending_method = this.sending_method[this.appointment.sending_method]

      this.attendedArray = this.appointment.attended.split(',')
      this.noticesArray = this.appointment.notices.split(',')
      this.sending_productsArray = this.appointment.sending_products.split(',')
      this.mediumArray = this.mediums

      if (this.appointment.transmission_item_company === 1) { this.watch.transmission_item_company = true } else { this.watch.transmission_item_company = false }
      if (this.appointment.transmission_item_course === 1) { this.watch.transmission_item_course = true } else { this.watch.transmission_item_course = false }
      if (this.appointment.transmission_item_visitor === 1) { this.watch.transmission_item_visitor = true } else { this.watch.transmission_item_visitor = false }
      if (this.appointment.transmission_item_purpose === 1) { this.watch.transmission_item_purpose = true } else { this.watch.transmission_item_purpose = false }
      if (this.appointment.transmission_item_requiredtime === 1) { this.watch.transmission_item_requiredtime = true } else { this.watch.transmission_item_requiredtime = false }

      this.edit_id.appointment_id = appointment.id
    },
    cancelAppointment () {
      this.$store.dispatch('cancelAppointment', {
        edit_id: this.edit_id
      })
    },
    patchNote (list, $event) {
      list.note = $event
      // console.log($event)
      // console.log(list)
    },
    patchAppointment (appointment) {
      if (this.mediumArray.length < 3) {
        this.mediumArray.push(0) // 3つ、もしくは2つ入っていたものそれ以下でpatchすると重複するので一旦これで
        this.mediumArray.push(0)
        this.$store.dispatch('patchAppointment', {
          this: this,
          appointment: appointment,
          attended: this.attended,
          notices: this.notices,
          sending_products: this.sending_products,
          mediumArray: this.mediumArray,
          geometry: this.geometry,
          edit_id: this.edit_id
        })
      }
      this.$store.dispatch('patchAppointment', {
        this: this,
        appointment: appointment,
        attended: this.attended,
        notices: this.notices,
        sending_products: this.sending_products,
        mediumArray: this.mediumArray,
        geometry: this.geometry,
        edit_id: this.edit_id
      })
    },
    getYubin (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.appointment.address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            // console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '1. 北海道', value: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '2. 青森県', value: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '3. 秋田県', value: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '4. 岩手県', value: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '5. 山形県', value: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '6. 宮城県', value: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '7. 福島県', value: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '8. 栃木県', value: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '9. 山梨県', value: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '10. 群馬県', value: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '11. 茨城県', value: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '12. 千葉県', value: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '13. 埼玉県', value: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '14. 東京都', value: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '15. 神奈川県', value: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '16. 静岡県', value: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '17. 長野県', value: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '18. 愛知県', value: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '19. 岐阜県', value: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '20. 新潟県', value: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '21. 富山県', value: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '22. 石川県', value: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '23. 福井県', value: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '24. 滋賀県', value: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '25. 京都府', value: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '26. 三重県', value: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '27. 和歌山県', value: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '28. 奈良県', value: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '29. 大阪府', value: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '30. 兵庫県', value: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '31. 鳥取県', value: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '32. 島根県', value: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '33. 岡山県', value: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '34. 広島県', value: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '35. 山口県', value: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '36. 高知県', value: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '37. 徳島県', value: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '38. 香川県', value: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '39. 愛媛県', value: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '40. 福岡県', value: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '41. 佐賀県', value: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '42. 長崎県', value: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '43. 熊本県', value: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '44. 宮崎県', value: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '45. 大分県', value: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '46. 鹿児島県', value: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '47. 沖縄県', value: 47 }
            }
            that.appointment.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.errors {
  color: red;
  font-size: .85rem;
}
.fa-pencil-square-o {
  margin-right: 5px;
  font-weight: bold;
}
.req {
  background: #dffbef;
}
.m-box__inner {
  display: flex;
  flex-flow: wrap;
  /* margin: 0; */
}
.m-detail {
  width: 33%;
  font-size: 11px;
  th {
    width: 35%;
    height: 25px;
  }
  /* td { */
  /*   width: 65%; */
  /* } */
}
.note {
  border-spacing: 0;
  width: 100%;
  font-size: 11px;
  th {
    border-top: solid 1px #e6e4e4;
    width: 10%;
    height: 25px;
  }
  td {
    border-top: solid 1px #e6e4e4;
    width: 90%;
    word-break: break-word;
    textarea {
      font-size: 11px;
      height: 300px;
    }
  }
}
.center {
  border-left: solid 1px #eee;
  border-right: solid 1px #eee;
}
td {
  padding: 0 !important;
  height: 30px;
  input {
    width: 100%;
    font-size: 11px;
    border: none;
    height: 30px;
    background: none;
    &.name_w {
      width: 50%;
    }
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  textarea {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 100px;
    background: none;
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  .calc {
    padding: 8px;
  }
}
.cancel {
  margin-top: 0 !important;
}
.fa-pencil {
  margin-right: 5px;
  font-weight: bold;
}
.checkbox {
  font-size: .85rem;
  color: #333;
  div {
    display: flex;
    label {
      padding-top: 9px;
      padding-left: 5px;
    }
    input {
      height: 29px;
      width: 20px;
    }
  }
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
</style>
<style lang="scss">
.AppointmentProfile {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    background: none;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: 11px;
    background: none;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding-top: 7px;
    padding-left: 5px;
    margin-bottom: 0;
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentProfile.vue?aa0bc0d0